var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSearchFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1266_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.339 310.656C347.101 303.259 358.322 299.423 369.778 299.907C381.235 300.391 392.092 305.16 400.199 313.27L486.597 399.667C490.846 403.916 494.215 408.96 496.515 414.512C498.814 420.063 499.998 426.014 499.998 432.023C499.998 438.033 498.814 443.983 496.515 449.535C494.215 455.087 490.844 460.131 486.595 464.38L464.379 486.597C455.796 495.178 444.157 499.998 432.021 499.998C419.884 499.998 408.245 495.178 399.662 486.597L313.263 400.2C305.152 392.095 300.382 381.239 299.897 369.782C299.413 358.326 303.251 347.105 310.648 338.344L297.813 325.509C307.999 317.292 317.286 308.006 325.503 297.82L338.339 310.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 174,
    r: 140,
    stroke: "white",
    strokeWidth: 68
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1266_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearchFill);
export default __webpack_public_path__ + "static/media/ico_search_fill.4b7dd7b6e4022865d520ffd6610a5b20.svg";
export { ForwardRef as ReactComponent };